import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import api from "./api";
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";

export function loadExposure(documentId, siteId) {
  return async (dispatch, getState) => {
    const key = `${documentId}-${siteId}`;
    let loading = false,
      loaded = false;
    const flags = getState().document.exposure[key];
    if (flags) {
      loading = flags.loading;
      loaded = flags.loaded;
    }

    if (loading || loaded) return;

    try {
      dispatch({ type: actionTypes.LOAD_EXPOSURE_STARTED, id: key });
      const exposure = await dispatch(sendHttpRequest(api.loadExposure(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_EXPOSURE_SUCCESS, payload: exposure, id: key });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function computeExposure(documentId, siteId) {
  return async dispatch => {
    const key = `${documentId}-${siteId}`;
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(api.computeExposure(documentId, siteId), "computeExposureCommand", [
          eventTypes.EXPOSURE_COMPUTED
        ])
      );

      if (event.ok) {
        dispatch({ type: actionTypes.COMPUTE_EXPOSURE_SUCCESS, id: key });
      }

      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function retrieveExposureCurrencies(documentId, siteId) {
  return async dispatch => {
    const key = `${documentId}-${siteId}`;
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          api.retrieveExposureCurrencies(documentId, siteId),
          "retrieveExposureCurrenciesCommand",
          [eventTypes.EXPOSURE_CURRENCIES_RETRIEVED]
        )
      );
      if (event.ok) {
        dispatch({ type: actionTypes.RETRIEVE_EXPOSURE_CURRENCIES_SUCCESS, id: key });
      }
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
